export { default } from './badge'
export type { Props as BadgeProps } from './badge'
